import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from 'material-ui/Slider';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { setZoom } from '../../actions';
import history from '../../history'

export class ZoomSwitch extends Component {

  constructor(props) {
    super(props);
    this.handleSlider = this.handleSlider.bind(this);
    this.state = { zoom: 10 }
  }

  componentDidMount() {
    if(window.location.pathname !== '/zoom') {
      this.props.setZoom(null, 0);
    }
    window.addEventListener('wheel', this.handleSlider);
  }

  componentWillUnmount() {
    window.removeEventListener('wheel', this.handleSlider);
  }

  handleSlider = (event, value) => {
    if(value === undefined){
      let z = this.state.zoom+event.deltaY
      if(z > 20){
        z = 20
      }else if(z < 0) {
        z = 0
      }
      this.setState({ zoom: z })
    }

    if(value === 1 || this.state.zoom > 15) {
      this.props.setZoom(event, 1);
      history.push('/zoom')
    } else if(window.location.pathname === '/zoom' &&
       (value === 0 || this.state.zoom < 5) ){
      this.props.setZoom(event, 0);
      history.goBack()
    }
  };

  render() {
    return (
      <div className='zoom'>
        <MuiThemeProvider>
          <i className="fas fa-search-minus fa-2x"
            onClick={e => this.handleSlider(e, 1)} style={{cursor: 'pointer'}} />
          <Slider style={{height: 50}} axis="y" step={1}
            onChange={this.handleSlider} value={this.props.client.zoom}/>
          <br />
          <i className="fas fa-search-plus fa-2x"
            onClick={e => this.handleSlider(e, 0)} style={{cursor: 'pointer'}} />
        </MuiThemeProvider>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
});

const mapDispatchToProps = {
  setZoom
}

export default connect(mapStateToProps, mapDispatchToProps)(ZoomSwitch)



// WEBPACK FOOTER //
// ./src/components/fixedComponents/ZoomSwitch.js